import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { delay, debounce } from 'lodash';
import Confetti from 'react-dom-confetti';

function r(min, max) {
  return (Math.random() * (max - min)) + min;
}

function getConfig() {
 return {
    angle: r(45, 135),
    spread: r(50, 70),
    elementCount: r(50, 100),
    startVelocity: 40,
    dragFriction: 0.12,
    duration: 3000,
    stagger: 3,
    width: '10px',
    height: '10px',
    perspective: '500px',
    colors: ['#a864fd', '#29cdff', '#78ff44', '#ff718d', '#fdff6a'],
  }
}

class Delightable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      play: false,
      confetti: {},
    };
    this.handleClick = this.handleClick.bind(this);
    this.play = debounce(this.play, 1000, { leading: true, trailing: false }).bind(this);
  }

  play() {
    this.setState({ play: true, confetti: getConfig() }, () => {
      delay(() => {
        this.setState({ play: false });
      }, 3000);
    });
  }
  
  handleClick(e) {
    e.preventDefault();
    this.play();
  }

  render() {
    const { children } = this.props;
    return (
      <strong style={{ cursor: 'pointer' }} onClick={this.handleClick}>
        {children}
        <span style={{ display: 'inline-block', position: 'relative' }}><Confetti active={this.state.play} config={this.state.confetti} /></span>
      </strong>
    );
  }
}

Delightable.propTypes = {
  children: PropTypes.node,
};

Delightable.defaultProps = {
  children: null,
};


export default Delightable;
